import React from 'react';

const Privacy = () => {
    return (
        <main
            style={{
                padding: '24px',
                maxWidth: 900,
                margin: '0 auto',
                fontFamily: 'Inter, Arial, sans-serif',
                lineHeight: 1.6,
                color: '#0f172a',
            }}
        >
            <header style={{ marginBottom: 24 }}>
                <h1 style={{ margin: 0 }}>Politique de confidentialité – TIGOON Connect</h1>
                <p style={{ margin: '6px 0 0', color: '#475569' }}>
                    Date de dernière mise à jour&nbsp;: <strong>14 août 2025</strong>
                </p>
            </header>

            <section>
                <p>
                    La présente politique explique comment <strong>TIGOON Connect</strong> collecte, utilise,
                    conserve et protège vos informations lors de l’utilisation de notre application mobile et
                    de notre tableau de bord web destinés aux chauffeurs.
                </p>
            </section>

            <hr />

            <section id="donnees-collectees">
                <h2>1. Données que nous collectons</h2>
                <ul>
                    <li>
                        <strong>Identifiants de compte</strong> : numéro de téléphone (identifiant), mot de
                        passe (stocké de façon chiffrée).
                    </li>
                    <li>
                        <strong>Informations personnelles</strong> : nom, adresse e-mail, au besoin pour le
                        support et la gestion du compte.
                    </li>
                    <li>
                        <strong>Informations véhicule</strong> : immatriculation, modèle, type.
                    </li>
                    <li>
                        <strong>Journaux d’activité</strong> : opérations effectuées dans l’application (par
                        ex. connexions, actions métier) pour assurer la sécurité et la traçabilité.
                    </li>
                </ul>
                <p style={{ color: '#475569' }}>
                    Nous ne collectons que les données strictement nécessaires au fonctionnement du service.
                </p>
            </section>

            <section id="utilisation">
                <h2>2. Finalités d’utilisation</h2>
                <ul>
                    <li>Créer et gérer votre compte chauffeur et authentifier l’accès.</li>
                    <li>Assurer la fourniture des fonctionnalités et le suivi des services.</li>
                    <li>Améliorer la qualité, la fiabilité et la sécurité de la plateforme.</li>
                    <li>Vous assister via le support client et communiquer des informations importantes.</li>
                </ul>
            </section>

            <section id="partage">
                <h2>3. Partage avec des tiers</h2>
                <p>
                    Nous ne vendons ni ne louons vos données. Elles peuvent être partagées uniquement avec des
                    prestataires techniques (hébergement, messagerie, analytics internes strictement
                    nécessaires) agissant pour notre compte et soumis à des obligations de
                    confidentialité/ sécurité équivalentes.
                </p>
            </section>

            <section id="securite">
                <h2>4. Sécurité</h2>
                <ul>
                    <li>Chiffrement des communications (HTTPS/TLS).</li>
                    <li>Stockage des mots de passe via un algorithme de hachage sécurisé.</li>
                    <li>Contrôles d’accès et journalisation des actions sensibles.</li>
                </ul>
            </section>

            <section id="conservation">
                <h2>5. Conservation</h2>
                <p>
                    Les données sont conservées pendant la durée d’utilisation du service et, au-delà, pour la
                    période strictement nécessaire au respect de nos obligations légales et à la défense de nos
                    droits. Passé ces délais, elles sont supprimées ou anonymisées de manière sécurisée.
                </p>
            </section>

            <section id="vos-droits">
                <h2>6. Vos droits</h2>
                <p>
                    Vous pouvez exercer vos droits d’<strong>accès</strong>, de <strong>rectification</strong>{' '}
                    ou de <strong>suppression</strong> de vos données personnelles, <strong>y compris la
                        suppression définitive de votre compte utilisateur</strong>, en nous écrivant à&nbsp;:
                    {' '}
                    <a href="mailto:support@tigoon.ci">support@tigoon.ci</a>.
                </p>
                <p style={{ marginTop: 12 }}>
                    Pour accélérer le traitement, indiquez votre numéro de téléphone (identifiant du compte)
                    et précisez l’objet de la demande (ex.&nbsp;: «&nbsp;Suppression de compte&nbsp;»).
                </p>

                <div
                    style={{
                        background: '#f1f5f9',
                        border: '1px solid #e2e8f0',
                        padding: 16,
                        borderRadius: 8,
                        marginTop: 12,
                    }}
                >
                    <strong>Demander la suppression de votre compte</strong>
                    <div style={{ marginTop: 8 }}>
                        <a
                            href="mailto:support@tigoon.ci?subject=Suppression%20de%20compte%20TIGOON%20Connect&body=Bonjour,%20je%20souhaite%20supprimer%20mon%20compte%20TIGOON%20Connect.%20Identifiant%20(num%C3%A9ro%20de%20t%C3%A9l%C3%A9phone)%20:%20_____%0D%0A"
                            style={{
                                display: 'inline-block',
                                padding: '10px 14px',
                                background: '#0ea5e9',
                                color: '#fff',
                                borderRadius: 6,
                                textDecoration: 'none',
                            }}
                        >
                            Envoyer une demande de suppression
                        </a>
                    </div>
                </div>
            </section>

            <section id="mineurs">
                <h2>7. Utilisateurs mineurs</h2>
                <p>
                    Le service est destiné aux <strong>adultes (18&nbsp;ans et plus)</strong>. Nous ne
                    visons pas les enfants et ne collectons pas sciemment leurs données.
                </p>
            </section>

            <section id="modifs">
                <h2>8. Modifications de cette politique</h2>
                <p>
                    Nous pouvons mettre à jour la présente politique. Les changements seront publiés sur cette
                    page avec la date de mise à jour. En cas de modification significative, nous vous en
                    informerons par un moyen approprié.
                </p>
            </section>

            <section id="contact">
                <h2>9. Contact</h2>
                <p>
                    Pour toute question relative à la confidentialité ou à cette politique, contactez notre
                    support&nbsp;: <a href="mailto:support@tigoon.ci">support@tigoon.ci</a>.
                </p>
            </section>
        </main>
    );
};

export default Privacy;
